import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActiveCompartmentsModel } from '../../../store/state/monitoring/allocation-view';
import { UliActivityType } from '../../../common/constants';

@Component({
  selector: 'ui-compartment-select',
  templateUrl: './compartment-select.component.html',
  styleUrls: ['./compartment-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompartmentSelectComponent<T extends { fullAddress: string }, U> {
  @Input() fieldLabel: string;
  @Input() fieldControl: FormControl<T>;
  @Input() filterControl?: FormControl<U>;
  @Input() testId: string;
  @Input() disabled: boolean;
  @Input() compartmentList: ActiveCompartmentsModel[];
  @Input() activityType: UliActivityType;
}
